import {
  SET_CURRENT_ITEM_CATEGORY,
  SET_CURRENT_ACTIVE_CATELOGE_ID,
  SET_CURRENT_ACTIVE_CATEGORY_ID,
  GET_ALL_GLOBAL_CATELOGE,
  GET_ALL_GLOBAL_CATELOGE_CATEGORY,
  GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM,
  SET_ALL_COMPLETE_ITEMS,
} from "../../types";

const initial_state = {
  setCurrentCategory: {},
  set_current_active_cateloge_id: "",
  set_current_active_category_id: "",
  getAllGlobalCateloge: [],
  getAllGlobalCatelogeCategory: [],
  getAllGlobalCatelogeCategoryItem: [],
  set_all_complete_items: [],
};

export default function (state = initial_state, action) {
  switch (action.type) {
    case SET_CURRENT_ITEM_CATEGORY:
      return { ...state, setCurrentCategory: action.payload };
    case SET_CURRENT_ACTIVE_CATELOGE_ID:
      return { ...state, set_current_active_cateloge_id: action.payload };
    case SET_CURRENT_ACTIVE_CATEGORY_ID:
      return { ...state, set_current_active_category_id: action.payload };
    case GET_ALL_GLOBAL_CATELOGE:
      return { ...state, getAllGlobalCateloge: action.payload };
    case GET_ALL_GLOBAL_CATELOGE_CATEGORY:
      return { ...state, getAllGlobalCatelogeCategory: action.payload };
    case GET_ALL_GLOBAL_CATELOGE_CATEGORY_ITEM:
      return { ...state, getAllGlobalCatelogeCategoryItem: action.payload };
    case SET_ALL_COMPLETE_ITEMS:
      return { ...state, set_all_complete_items: action.payload };
    default:
      return state;
  }
}
